export default "__VITE_ASSET__B7zE_hdt__"